import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { PessoaTipoMultiselectModule } from '../../../pessoa/tipo/multiselect';
import { EstadoMultiselectModule } from '../../../estado/multiselect';
import { CidadeModule } from '../../../cidade';
import { ClassificacaoTipoMultiselectModule } from '../../../classificacao/tipo/multiselect';
import { UsuarioMultiselectModule } from '../../../usuario/multiselect';
import { TemperaturaMultiselectModule } from '../../../common/temperatura/multiselect';
import { OrigemMultiselectModule } from '../../../common/origens/components/multiselect';
import { CampanhaMultiselectModule } from '../../../campanhas/campanhas/components/multiselect';
import { CanalVendaMultiselectModule } from '../../../common/canais-venda/components/multiselect';
import { CanalMidiaSocialmMultiselectModule } from '../../../common/canal-midia-social/components/multiselect';
import { RegiaoMultiselectModule } from '../../../regiao/multiselect';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { LeadFilterComponent } from './lead-filter.component';

@NgModule({
    imports: [
        SharedModule,
        PessoaTipoMultiselectModule,
        EstadoMultiselectModule,
        CidadeModule,
        ClassificacaoTipoMultiselectModule,
        UsuarioMultiselectModule,
        TemperaturaMultiselectModule,
        OrigemMultiselectModule,
        CampanhaMultiselectModule,
        CanalVendaMultiselectModule,
        CanalMidiaSocialmMultiselectModule,
        NgxBootstrapMultiselectModule,
        RegiaoMultiselectModule
    ],
    declarations: [
        LeadFilterComponent
    ],
    exports: [
        LeadFilterComponent
    ]
})
export class LeadFilterModule { }
